import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';

 
class CMMessageContent extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            content : [],
            page_content:[],
            loading : 1,
            settings:{}
        }
        

    }

    componentDidMount()
    {
         this.setState({loading:0})
           
    }


    render()
    { 
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
    return (
        <div>
 <div class="section-full p-t80 p-b0 bg-white">
                <div class="container">
        <div class="row">
              
              <div class="about-content">
                  <div class="col-md-5">
                      <div class="thumb">
                          <img src={this.props.content[13].image} alt={this.props.content[13].title} className='cm-img' />  
                      </div>
                  </div>
                  <div class="col-md-7 info-content"> 
                     <h2 class="text-uppercase"><div  dangerouslySetInnerHTML={{ __html: this.props.content[13].title}} /></h2> 
                      <div  dangerouslySetInnerHTML={{ __html: this.props.content[13].description}} />  
                  </div>
              </div>
              
          </div>
         
          
        </div>
    </div>
 
        </div>
       

    );
 
    }
}

export default CMMessageContent;